<template>
	<section>
		<div v-if="showParentView('page-module')">
			<header-page
				name="modules"
				:title="$route.meta.title"
			/>
			<module-list
				:columns="columns"
				:current-page="currentPage"
				:rows="table.rows"
				:last-page="table.lastPage"
				@change-page="changePage"
				@on-delete="loadData('modules')"
				@on-search="onSearch($event, 'modules')"
			/>
			<quick-actions
				:actions="actions"
				@open-modal="openModal"
			>
			</quick-actions>
		</div>
		<router-view></router-view>
	</section>
</template>

<script>
import quickActions from '@/components/shared/quick-actions';
import moduleList from '@/components/modules/module-list';

function created() {
	this.params.codeApp = this.codeApp;
	this.loadData('modules');
}

function changePage(page) {
	this.params.page = page;
	this.currentPage = page;
	this.loadData('modules');
}

function data() {
	return {
		actions: [
			{
				id: 1,
				code: 'CM',
				text: 'Crear Módulo',
				icon: 'view_module',
				active: true,
			},
		],
		columns: [
			{ id: 1, name: 'Módulo', checked: true, visible: true },
			{ id: 2, name: 'Descripción', checked: true, visible: true },
			{ id: 3, name: 'Aplicación', checked: true, visible: true },
			{ id: 4, name: 'Recursos', checked: true, visible: true },
			{ id: 5, name: 'Posición', checked: true, visible: true },
			{ id: 6, name: 'Acciones', checked: true, visible: true, flagVisible: true },
		],
		currentPage: 1,
	};
}

function openModal() {
	this.goTo('page-module-new');
}

export default {
	name: 'page-module',
	created,
	components: {
		moduleList,
		quickActions,
	},
	data,
	methods: {
		changePage,
		openModal,
	},
	props: {
		codeApp: {
			type: String,
		},
	},
	watch: {
		$route(newVal) {
			if (newVal) {
				if (newVal.name === 'page-module') {
					this.params.codeApp = this.codeApp;
					this.loadData('modules');
				}
			}
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/pages/modules/page-module.vue